import { AuthProvider, useAuth } from './auth/AuthContext'
import { supabaseConfigured } from './lib/supabase'
import Connexion from './pages/Connexion'
import Accueil from './pages/Accueil'
import { AccesRefuse, Chargement, ConfigurationManquante } from './pages/Messages'

function Porte() {
  const { loading, session, appUser } = useAuth()
  if (loading) return <Chargement />
  if (!session) return <Connexion />
  if (!appUser) return <AccesRefuse />
  return <Accueil />
}

/** Application ERP KD — Phase 1 (Supabase). */
export default function KdApp() {
  if (!supabaseConfigured) return <ConfigurationManquante />
  return (
    <AuthProvider>
      <Porte />
    </AuthProvider>
  )
}
